module.exports = "https://trybtryb-legacy.web.app/img/lusanda.fff47f09.webp";